<div class="container">
  <mic-breadcrumb id="zone-setup-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('setupText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link link="/home/setup/zoneSetup" label="{{ translationService.translate('zoneSetupText') }}"></mic-breadcrumb-link>
  </mic-breadcrumb>

  @if (isLoaded) {
  <form [formGroup]="zoneForm">
    <div class="flex items-center justify-between mt-3 mb-4">
      <h3 class="m-0" id="plant-setup-heading">
        {{ translationService.translate('generalOptionsText') }}
      </h3>
      <div>
        @if (saveEnabled) {
        <button id="cancel-button" type="button" mat-flat-button color="accent" (click)="cancel()" style="margin-right: 10px">
          <mat-icon>cancel</mat-icon> {{ translationService.translate('cancelLinkText') }}
        </button>
        <button id="save-button" type="button" mat-flat-button color="primary" (click)="save()">
          <mat-icon>save</mat-icon> {{ translationService.translate('saveLinkText') }}
        </button>
        }
      </div>
    </div>
    <!--General Options-->
    <mat-accordion>
      <mat-expansion-panel expanded="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ translationService.translate('generalOptionsText') }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-divider></mat-divider>
        <div class="grid mt-3" [formGroup]="zoneSetupDetails">
          <div class="grid gap-5 items-center grid-cols-4 grid-flow-row">
            <!-- ZoneID -->
            <mat-form-field appearance="outline" id="mat_zone" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('zoneText') }}</mat-label>
              <mat-select type="text" [formControlName]="'zoneId'">
                @for (option of zones; track option) {
                <mat-option [value]="option"> {{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <!-- Export Directory -->
            <mat-form-field appearance="outline" id="mat_export_directory" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('exportDirectoryText') }}</mat-label>
              <input id="exportDirectory" matInput type="text" [formControlName]="'exportDirectory'" />
              @if (zoneSetupDetails.get('exportDirectory')?.hasError('required')) {
              <mat-error>
                {{ translationService.translate('thisIsMandatoryFieldText') }}
              </mat-error>
              }
            </mat-form-field>
            <!-- Adjust Calc Method -->
            <mat-form-field appearance="outline" id="mat_adj_calc_mthd" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('adjustCalcMethodText') }}</mat-label>
              <mat-select type="text" [formControlName]="'adjCalcMthd'">
                @for (option of ['1', '2', '3']; track option) {
                <mat-option [value]="option"> {{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <!-- Opt Cust Code -->
            <mat-form-field appearance="outline" id="mat_opt_cust_code" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('optCustCodeText') }}</mat-label>
              <mat-select type="text" [formControlName]="'optCustCode'">
                @for (option of optCustCodes; track option) {
                <mat-option [value]="option"> {{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <!-- Reuse Bar Code -->
            <mat-form-field appearance="outline" id="mat_reuse_bar_codes" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('reuseBarCodesText') }}</mat-label>
              <mat-select type="text" [formControlName]="'reuseBarCodes'">
                @for (option of ynOptions; track option) {
                <mat-option [value]="option"> {{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <!-- Print Bar Code -->
            <mat-form-field appearance="outline" id="mat_print_bar_codes" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('printBarCodesText') }}</mat-label>
              <mat-select type="text" [formControlName]="'printBarCodes'">
                @for (option of ynOptions; track option) {
                <mat-option [value]="option"> {{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <!-- Work Order Prefix -->
            <mat-form-field appearance="outline" id="mat_work_order_prefix" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('workOrderPrefixText') }}</mat-label>
              <input id="workOrderPrefix" matInput type="text" [formControlName]="'workOrderPrefix'" />
            </mat-form-field>
            <!-- Check Cam Spec -->
            <mat-form-field appearance="outline" id="mat_check_cam_specs" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('checkCamSpecsText') }}</mat-label>
              <mat-select type="text" [formControlName]="'checkCamSpecs'">
                @for (option of ynOptions; track option) {
                <mat-option [value]="option"> {{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <!-- Raw Materials -->
            <mat-form-field appearance="outline" id="mat_raw_materials" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('rawMaterialsText') }}</mat-label>
              <mat-select type="text" [formControlName]="'rawMaterials'">
                @for (option of rawMaterialOptions; track option) {
                <mat-option [value]="option"> {{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <!-- Raw Materials UOM -->
            <mat-form-field appearance="outline" id="mat_raw_materials_uom" class="col-span-1 w-full">
              <mat-label class="custom-label-error"
                >{{ translationService.translate('rawMaterialsText') }} + ' ' + {{ translationService.translate('uomText') }}</mat-label
              >
              <mat-select type="text" [formControlName]="'rawMaterialsUom'">
                @for (option of rawMaterialUOMOptions; track option) {
                <mat-option [value]="option"> {{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <!-- Date Display -->
            <mat-form-field appearance="outline" id="mat_date_display" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('dateDisplayText') }}</mat-label>
              <mat-select type="text" [formControlName]="'dateDisplay'">
                @for (option of dateDisplayOptions; track option) {
                <mat-option [value]="option"> {{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <!-- Tread Picture -->
            <mat-form-field appearance="outline" id="mat_tread_picture" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('treadPictureText') }}</mat-label>
              <mat-select type="text" [formControlName]="'treadPicture'">
                @for (option of ynOptions; track option) {
                <mat-option [value]="option"> {{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <!-- Max Login Failure -->
            <mat-form-field appearance="outline" id="mat_max_num_login" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('maxNumLoginText') }}</mat-label>
              <input id="maxNumLogin" matInput type="number" [formControlName]="'maxNumLogin'" />
            </mat-form-field>
            <!-- Different plant work orders -->
            <mat-form-field appearance="outline" id="mat_allow_casings_at_different_plants" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('allowCasingsAtDifferentPlantsText') }}</mat-label>
              <mat-select type="text" [formControlName]="'allowCasingsAtDifferentPlants'">
                @for (option of ynOptions; track option) {
                <mat-option [value]="option"> {{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <!-- Different plant new work order -->
            <mat-form-field appearance="outline" id="mat_different_plant_new_wo" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('differentPlantNewWOText') }}</mat-label>
              <mat-select type="text" [formControlName]="'differentPlantNewWO'">
                @for (option of ynOptions; track option) {
                <mat-option [value]="option"> {{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <!-- Change Zone Logo -->
            <div class="col-span-1 w-full flex flex-col">
              <label for="zoneLogoInput" class="custom-label-error mb-1">{{ translationService.translate('changeZoneLogoText') }}</label>
              <input id="zoneLogoInput" type="file" (change)="onZoneLogoSelected($event)" accept="image/*" class="file-input" />
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <!--Default Workflow-->
    <mat-accordion>
      <mat-expansion-panel expanded="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ translationService.translate('defaultWorkflowText') }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-divider></mat-divider>
        <div formArrayName="zonePosts">
          <div class="flex flex-wrap items-center justify-between overflow-x-auto">
            <mic-status class="primary mt-4">{{ translationService.translate('rRequiredYYesAvailableNNotAvailableText') }}</mic-status>
          </div>
          <div class="flex flex-wrap gap-x-32 gap-y-1 items-center mt-2">
            @for (postGroup of zonePosts.controls; track $index; let i = $index) {
            <div [formGroupName]="i" class="flex items-center gap-2 mt-1">
              <span class="w-36 shrink-0">{{ translationService.translate(getPostLabel(postGroup.get('postName').value)) }}</span>
              <mat-form-field appearance="outline" class="w-16 min-w-0 shrink-0">
                <mat-select formControlName="postActive">
                  @for (option of ynrOptions; track option) {
                  <mat-option [value]="option">{{ option }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            }
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <!--Default Process Codes / Workflows-->
    <mat-accordion>
      <mat-expansion-panel expanded="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ translationService.translate('defaultProcessCodesAndWorkflowsText') }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-divider></mat-divider>
        <div class="flex flex-wrap items-center justify-between overflow-x-auto">
          <mic-status class="primary mt-4">{{ translationService.translate('rRequiredYYesAvailableNNotAvailableText') }}</mic-status>
        </div>
        <div class="flex flex-col">
          <h3 style="font-size: 18px">
            {{ translationService.translate('processCodesWithSpecificWorkFlowsText') }}
          </h3>
          <div class="flex flex-row items-center overflow-x-auto">
            <span class="w-32 pr-8" style="font-weight: bolder">{{ translationService.translate('casingProcessCodeText') }}</span>
            <div class="workflow-list ml-0 mr-10">
              @for (item of postNames; track item) {
              <div class="post-names">
                {{ item }}
              </div>
              }
            </div>
          </div>
          <div class="flex flex-row items-center overflow-x-auto">
            <div class="flex flex-row items-center pr-2">
              <span class="w-20 pr-2">RR - {{ translationService.translate('repairAndRetreadText') }}</span>
              <mat-form-field appearance="outline" class="w-14 min-w-0 mt-4">
                <mat-select [formControl]="getProcessCodeControl('RR', 'active')">
                  @for (option of ynrOptions; track option) {
                  <mat-option [value]="option">
                    {{ option }}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div cdkDropList cdkDropListOrientation="horizontal" class="workflow-list ml-0" (cdkDropListDropped)="drop($event, 'RR')">
              @for (item of workflowItemsRR; track trackByIndex($index)) {
              <div class="workflow-box" cdkDrag>
                <span class="icon-dotted" cdkDragHandle>
                  <mat-icon>drag_indicator</mat-icon>
                </span>
                {{ translationService.translate(getPostLabel(item)) }}
                <span class="icon-delete" (click)="onDeleteWorkflowItem($index, 'RR')">
                  <mat-icon color="warn">delete</mat-icon>
                </span>
              </div>
              }
            </div>
            <div class="flex-1"></div>
            <mat-form-field appearance="outline" class="w-32 pt-4" id="addPostField">
              <mat-label class="custom-label-error">{{ translationService.translate('addPostText') }}</mat-label>
              <mat-select subscriptSizing="dynamic" id="addPost" (selectionChange)="onAddPost($event.value, 'RR')">
                @for (postName of getWorkflowPostNames('RR'); track postName) {
                <mat-option [value]="postName">
                  {{ translationService.translate(getPostLabel(postName)) }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="flex flex-row items-center overflow-x-auto">
            <div class="flex flex-row items-center pr-2">
              <span class="w-20 pr-2">RO - {{ translationService.translate('repairOnlyText') }}</span>
              <mat-form-field appearance="outline" class="w-14 min-w-0 mt-4">
                <mat-select [formControl]="getProcessCodeControl('RO', 'active')">
                  @for (option of ynrOptions; track option) {
                  <mat-option [value]="option">
                    {{ option }}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div cdkDropList cdkDropListOrientation="horizontal" class="workflow-list" (cdkDropListDropped)="drop($event, 'RO')">
              @for (item of workflowItemsRO; track trackByIndex($index)) {
              <div class="workflow-box" cdkDrag>
                <span class="icon-dotted" cdkDragHandle>
                  <mat-icon>drag_indicator</mat-icon>
                </span>
                {{ translationService.translate(getPostLabel(item)) }}
                <span class="icon-delete" (click)="onDeleteWorkflowItem($index, 'RO')">
                  <mat-icon color="warn">delete</mat-icon>
                </span>
              </div>
              }
            </div>
            <div class="flex-1"></div>
            <mat-form-field appearance="outline" class="w-32" id="addPostFieldRO">
              <mat-label class="custom-label-error">{{ translationService.translate('addPostText') }}</mat-label>
              <mat-select subscriptSizing="dynamic" id="addPostRO" (selectionChange)="onAddPost($event.value, 'RO')">
                @for (postName of getWorkflowPostNames('RO'); track postName) {
                <mat-option [value]="postName">
                  {{ translationService.translate(getPostLabel(postName)) }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="flex flex-row items-center overflow-x-auto">
            <div class="flex flex-row items-center pr-2">
              <span class="w-20 pr-2">RS - {{ translationService.translate('reserveAndStockText') }}</span>
              <mat-form-field appearance="outline" class="w-14 min-w-0 mt-4">
                <mat-select [formControl]="getProcessCodeControl('RS', 'active')">
                  @for (option of ynrOptions; track option) {
                  <mat-option [value]="option">
                    {{ option }}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div cdkDropList cdkDropListOrientation="horizontal" class="workflow-list" (cdkDropListDropped)="drop($event, 'RS')">
              @for (item of workflowItemsRS; track trackByIndex($index)) {
              <div class="workflow-box" cdkDrag>
                <span class="icon-dotted" cdkDragHandle>
                  <mat-icon>drag_indicator</mat-icon>
                </span>
                {{ translationService.translate(getPostLabel(item)) }}
                <span class="icon-delete" (click)="onDeleteWorkflowItem($index, 'RS')">
                  <mat-icon color="warn">delete</mat-icon>
                </span>
              </div>
              }
            </div>
            <div class="flex-1"></div>
            <mat-form-field appearance="outline" class="w-32" id="addPostFieldRS">
              <mat-label class="custom-label-error">{{ translationService.translate('addPostText') }}</mat-label>
              <mat-select subscriptSizing="dynamic" id="addPostRS" (selectionChange)="onAddPost($event.value, 'RS')">
                @for (postName of getWorkflowPostNames('RS'); track postName) {
                <mat-option [value]="postName">
                  {{ translationService.translate(getPostLabel(postName)) }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="flex flex-row items-center overflow-x-auto">
            <span class="w-20 pr-2">IO - {{ translationService.translate('inspectOnlyText') }}</span>
            <mat-form-field appearance="outline" class="w-14 min-w-0 mt-4 pr-2">
              <mat-select [formControl]="getProcessCodeControl('IO', 'active')">
                @for (option of ynrOptions; track option) {
                <mat-option [value]="option">
                  {{ option }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <div class="centered-box">
              {{ translationService.translate('initialInspectionText') }}
            </div>
          </div>
          <div class="flex flex-row items-center overflow-x-auto">
            <span class="w-20 pr-2">SO - {{ translationService.translate('serviceOnlyText') }}</span>
            <mat-form-field appearance="outline" class="w-14 min-w-0 mt-4 pr-2">
              <mat-select [formControl]="getProcessCodeControl('SO', 'active')">
                @for (option of ynrOptions; track option) {
                <mat-option [value]="option">
                  {{ option }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <div class="centered-box">
              {{ translationService.translate('initialInspectionText') }}
            </div>
          </div>
          <div class="flex flex-row items-center overflow-x-auto">
            <span class="w-20 pr-2">AD - {{ translationService.translate('adjustmentText') }}</span>
            <mat-form-field appearance="outline" class="w-14 min-w-0 mt-4 pr-2">
              <mat-select [formControl]="getProcessCodeControl('AD', 'active')">
                @for (option of ynrOptions; track option) {
                <mat-option [value]="option">
                  {{ option }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <div class="centered-box">
              {{ translationService.translate('adjustmentText') }}
            </div>
          </div>
          <h3 style="font-size: 18px">
            {{ translationService.translate('allOtherProcessCodesText') }}
          </h3>
          <div class="grid grid-cols-6 mt-4">
            <div class="grid grid-cols-2 gap-2">
              <span class="w-22 pt-2">BS - {{ translationService.translate('buildForStockText') }}</span>
              <mat-form-field appearance="outline" class="w-14">
                <mat-select [formControl]="getProcessCodeControl('BS', 'active')">
                  @for (option of ynrOptions; track option) {
                  <mat-option [value]="option">
                    {{ option }}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class="grid grid-cols-2 gap-2">
              <span class="w-22 pt-3">CC - {{ translationService.translate('casingCreditText') }}</span>
              <mat-form-field appearance="outline" class="w-14">
                <mat-select [formControl]="getProcessCodeControl('CC', 'active')">
                  @for (option of ynrOptions; track option) {
                  <mat-option [value]="option">
                    {{ option }}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class="grid grid-cols-2 gap-2">
              <span class="w-22 pt-2">CP - {{ translationService.translate('casingPurchaseText') }}</span>
              <mat-form-field appearance="outline" class="w-14">
                <mat-select [formControl]="getProcessCodeControl('CP', 'active')">
                  @for (option of ynrOptions; track option) {
                  <mat-option [value]="option">
                    {{ option }}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class="grid grid-cols-2 gap-2">
              <span class="w-22 pt-3">DS - {{ translationService.translate('dealerStockText') }}</span>
              <mat-form-field appearance="outline" class="w-14">
                <mat-select [formControl]="getProcessCodeControl('DS', 'active')">
                  @for (option of ynrOptions; track option) {
                  <mat-option [value]="option">
                    {{ option }}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class="grid grid-cols-2 gap-2">
              <span class="w-22 pt-3 pl-4">SC - {{ translationService.translate('scrapText') }}</span>
              <mat-form-field appearance="outline" class="w-14">
                <mat-select [formControl]="getProcessCodeControl('SC', 'active')">
                  @for (option of ynrOptions; track option) {
                  <mat-option [value]="option">
                    {{ option }}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class="grid grid-cols-2 gap-2">
              <span class="w-22 pt-3 pl-4">NP - {{ translationService.translate('noPickupText') }}</span>
              <mat-form-field appearance="outline" class="w-14">
                <mat-select [formControl]="getProcessCodeControl('NP', 'active')">
                  @for (option of ynrOptions; track option) {
                  <mat-option [value]="option">
                    {{ option }}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <!--Default Fields-->
    <mat-accordion>
      <mat-expansion-panel expanded="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ translationService.translate('defaultFieldsText') }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-divider></mat-divider>
        <div class="grid mt-3" [formGroup]="zoneSetupDetails">
          <div class="grid gap-5 items-center grid-cols-4 grid-flow-row">
            <!-- NTR -->
            <mat-form-field appearance="outline" id="mat_ntr" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('ntrText') }}</mat-label>
              <mat-select type="text" [formControlName]="'ntr'">
                @for (option of ynrOptions; track option) {
                <mat-option [value]="option"> {{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <!-- Buffed Circumference -->
            <mat-form-field appearance="outline" id="mat_buffed_circumference" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('buffedCircumferenceText') }}</mat-label>
              <mat-select type="text" [formControlName]="'buffedCircumference'">
                @for (option of ynrOptions; track option) {
                <mat-option [value]="option"> {{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <!-- Load-I -->
            <mat-form-field appearance="outline" id="mat_load_i" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('loadIText') }}</mat-label>
              <mat-select type="text" [formControlName]="'loadI'">
                @for (option of ynrOptions; track option) {
                <mat-option [value]="option"> {{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <!-- Speed-I -->
            <mat-form-field appearance="outline" id="mat_speed_i" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('speedIText') }}</mat-label>
              <mat-select type="text" [formControlName]="'speedI'">
                @for (option of ynrOptions; track option) {
                <mat-option [value]="option"> {{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <!-- Serial/Lot# for Tread -->
            <mat-form-field appearance="outline" id="mat_serial_lot_for_tread" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('serialLotForTreadText') }}</mat-label>
              <mat-select type="text" [formControlName]="'serialLotForTread'">
                @for (option of ynrOptions; track option) {
                <mat-option [value]="option"> {{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <!-- MFG-DOT -->
            <mat-form-field appearance="outline" id="mat_mfg_dot" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('mfgDotText') }}</mat-label>
              <mat-select type="text" [formControlName]="'mfgDot'">
                @for (option of ynrOptions; track option) {
                <mat-option [value]="option"> {{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <!-- CIA Pass/Fail -->
            <mat-form-field appearance="outline" id="mat_cia_pass_fail" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('ciaPassFailText') }}</mat-label>
              <mat-select type="text" [formControlName]="'ciaPassFail'">
                @for (option of ynrOptions; track option) {
                <mat-option [value]="option"> {{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <!-- Lot Number for CTC -->
            <mat-form-field appearance="outline" id="mat_lot_number_for_ctc" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('lotNumberForCtcText') }}</mat-label>
              <mat-select type="text" [formControlName]="'lotNumberForCtc'">
                @for (option of ynrOptions; track option) {
                <mat-option [value]="option"> {{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <!-- Tread -->
            <mat-form-field appearance="outline" id="mat_tread" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('treadText') }}</mat-label>
              <mat-select type="text" [formControlName]="'tread'">
                @for (option of ynrOptions; track option) {
                <mat-option [value]="option"> {{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <!-- Rubber Thickness -->
            <mat-form-field appearance="outline" id="mat_rubber_thickness" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('rubberThicknessText') }}</mat-label>
              <mat-select type="text" [formControlName]="'rubberThickness'">
                @for (option of ynrOptions; track option) {
                <mat-option [value]="option"> {{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <!-- Due Date -->
            <mat-form-field appearance="outline" id="mat_due_date" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('dueDateText') }}</mat-label>
              <mat-select type="text" [formControlName]="'dueDate'">
                @for (option of ynOptions; track option) {
                <mat-option [value]="option"> {{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <!-- Lot Number Field for Repairs -->
            <mat-form-field appearance="outline" id="mat_lot_number_for_repairs" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('lotNumberForRepairsText') }}</mat-label>
              <mat-select type="text" [formControlName]="'lotNumberForRepairs'">
                @for (option of ynrOptions; track option) {
                <mat-option [value]="option"> {{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <!-- Width -->
            <mat-form-field appearance="outline" id="mat_width" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('widthText') }}</mat-label>
              <mat-select type="text" [formControlName]="'width'">
                @for (option of ynrOptions; track option) {
                <mat-option [value]="option"> {{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <!-- CNPJ / Ship to Code -->
            <mat-form-field appearance="outline" id="mat_cnpj_ship_to_code" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('cnpjShipToCodeText') }}</mat-label>
              <mat-select type="text" [formControlName]="'cnpjShipToCode'">
                @for (option of ynrOptions; track option) {
                <mat-option [value]="option"> {{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <!-- Factory Code -->
            <mat-form-field appearance="outline" id="mat_factory_code" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('factoryCodeText') }}</mat-label>
              <mat-select type="text" [formControlName]="'factoryCode'">
                @for (option of ynrOptions; track option) {
                <mat-option [value]="option"> {{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <!-- Lot Number Field for Cement Glue -->
            <mat-form-field appearance="outline" id="mat_lot_number_for_cement_glue" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('lotNumberForCementGlueText') }}</mat-label>
              <mat-select type="text" [formControlName]="'lotNumberForCementGlue'">
                @for (option of ynrOptions; track option) {
                <mat-option [value]="option"> {{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <!-- Length -->
            <mat-form-field appearance="outline" id="mat_length" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('lengthText') }}</mat-label>
              <mat-select type="text" [formControlName]="'length'">
                @for (option of ynrOptions; track option) {
                <mat-option [value]="option"> {{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <!-- CTC -->
            <mat-form-field appearance="outline" id="mat_ctc" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('ctcText') }}</mat-label>
              <mat-select type="text" [formControlName]="'ctc'">
                @for (option of ynrOptions; track option) {
                <mat-option [value]="option"> {{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <!-- Sequence # -->
            <mat-form-field appearance="outline" id="mat_sequence_number" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('sequenceNumberText') }}</mat-label>
              <mat-select type="text" [formControlName]="'sequenceNumber'">
                @for (option of ynrOptions; track option) {
                <mat-option [value]="option"> {{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <!-- Lot Number Field for Repair Gum -->
            <mat-form-field appearance="outline" id="mat_lot_number_for_repair_gum" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('lotNumberForRepairGumText') }}</mat-label>
              <mat-select type="text" [formControlName]="'lotNumberForRepairGum'">
                @for (option of ynrOptions; track option) {
                <mat-option [value]="option"> {{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <!-- Curing Result -->
            <mat-form-field appearance="outline" id="mat_curing_result" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('curingResultText') }}</mat-label>
              <mat-select type="text" [formControlName]="'curingResult'">
                @for (option of ynrOptions; track option) {
                <mat-option [value]="option"> {{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <!-- Rerun / Rework Options -->
    <mat-accordion>
      <mat-expansion-panel expanded="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ translationService.translate('rerunReworkOptionsText') }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-divider></mat-divider>
        <div class="flex flex-col gap-2 mt-3" [formGroup]="zoneSetupDetails">
          <!-- Rework - R1 -->
          <div class="flex items-center gap-3">
            <span class="w-36">{{ translationService.translate('reworkText') }} - R1</span>
            <mat-form-field appearance="outline" id="mat_rework_r1_enable" class="w-48">
              <mat-select type="text" [formControlName]="'reworkR1Enable'">
                @for (option of ynOptions; track option) {
                <mat-option [value]="option"> {{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <!-- Rework - R3 -->
          <div class="flex items-center gap-3">
            <span class="w-36">{{ translationService.translate('reworkText') }} - R3</span>
            <mat-form-field appearance="outline" id="mat_rework_r3_enable" class="w-48">
              <mat-select type="text" [formControlName]="'reworkR3Enable'">
                @for (option of ynOptions; track option) {
                <mat-option [value]="option"> {{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <!-- RRT -->
          <div class="flex items-center gap-3">
            <span class="w-36">RRT</span>
            <mat-form-field appearance="outline" id="mat_rerun_b_enable" class="w-48">
              <mat-select type="text" [formControlName]="'rerunBEnable'">
                @for (option of ynOptions; track option) {
                <mat-option [value]="option"> {{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <!-- RAR -->
          <div class="flex items-center gap-3">
            <span class="w-36">RAR</span>
            <mat-form-field appearance="outline" id="mat_casing_dead" class="w-48">
              <mat-select type="text" [formControlName]="'casingDead'">
                @for (option of ynOptions; track option) {
                <mat-option [value]="option"> {{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <!-- Rework - RFID -->
          <div class="flex items-center gap-3">
            <span class="w-36">{{ translationService.translate('reworkText') }} - RFID</span>
            <mat-form-field appearance="outline" id="mat_rework_rfid_enable" class="w-48">
              <mat-select type="text" [formControlName]="'reworkRFIDEnable'">
                @for (option of ynOptions; track option) {
                <mat-option [value]="option"> {{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <!-- Purge / Archive Options -->
    <mat-accordion>
      <mat-expansion-panel expanded="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ translationService.translate('purgeArchiveOptionsText') }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-divider></mat-divider>
        <div class="flex flex-col gap-2 mt-3" [formGroup]="zoneSetupDetails">
          <!-- Archive Active -->
          <div class="flex items-center gap-3">
            <span class="w-36">{{ translationService.translate('archiveActiveText') }}</span>
            <mat-form-field appearance="outline" id="mat_archive_active" class="w-48">
              <mat-select type="text" [formControlName]="'archiveActive'">
                @for (option of ynOptions; track option) {
                <mat-option [value]="option"> {{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <!-- Purge Active -->
          <div class="flex items-center gap-3">
            <span class="w-36">{{ translationService.translate('purgeActiveText') }}</span>
            <mat-form-field appearance="outline" id="mat_purge_active" class="w-48">
              <mat-select type="text" [formControlName]="'purgeActive'">
                @for (option of ynOptions; track option) {
                <mat-option [value]="option"> {{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </form>
  } @else {
  <ng-container>
    <mic-empty-state icon="layers_clear" title="{{ translationService.translate('noDataFoundText') }}"></mic-empty-state>
  </ng-container>
  }
</div>

<mic-modal class="modalC" #discardConfirmation>{{ translationService.translate('unSaveChangesText') }}</mic-modal>
<ng-template #discardContent>{{ translationService.translate('unSaveChangesText') }}</ng-template>
